var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group",class:_vm.formGroupClass},[(_vm.label)?_c('form-label',{attrs:{"for":_vm.id}},[_vm._v("\n\t\t"+_vm._s(_vm.label)+"\n\t")]):_vm._e(),_vm._v(" "),_c('textarea-autosize',_vm._b({ref:"textarea",staticClass:"form-control",class:{
		'is-invalid': _vm.$hasErrors(_vm.errors), 
		'w-100': !_vm.label,
		'border-0': !_vm.border,
	},attrs:{"id":_vm.id,"value":_vm.val,"minHeight":70},on:{"input":_vm.input}},'textarea-autosize',_vm.$attrs,false)),_vm._v(" "),_c('form-errors',_vm._b({},'form-errors',{errors: _vm.errors},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }